import AllhomesAgentProfileGraphQL from './allhomes-agent-profile-graphql';
export default AllhomesAgentProfileGraphQL;